import { useEffect, useMemo, useState } from 'react';
import { getRealtimeClient } from '../utils/realtimeClient';

const getIsConnected = (pusher) => {
  const state = pusher?.connection?.state;
  return state === 'connected';
};

export default function useSoketi() {
  const [enabled, setEnabled] = useState(false);
  const [connected, setConnected] = useState(false);
  const [pusher, setPusher] = useState(null);
  const [error, setError] = useState(null);
  const [lastState, setLastState] = useState(null);
  const [lastSocketError, setLastSocketError] = useState(null);

  useEffect(() => {
    let active = true;
    let cleanup = null;

    (async () => {
      try {
        console.info('[Realtime] useSoketi init');
        const result = await getRealtimeClient();
        if (!active) return;
        setError(null);
        setEnabled(Boolean(result.enabled));
        setPusher(result.pusher || null);
        setConnected(getIsConnected(result.pusher));
        console.info('[Realtime] client result', {
          enabled: Boolean(result.enabled),
          connected: getIsConnected(result.pusher),
        });

        if (result.pusher?.connection) {
          const handler = () => {
            if (!active) return;
            setConnected(getIsConnected(result.pusher));
            setLastState(result.pusher?.connection?.state || null);
          };
          result.pusher.connection.bind('error', (evt) => {
            if (!active) return;
            console.error('[Realtime] socket error', evt);
            setLastSocketError(evt?.error?.message || evt?.message || 'Realtime connection error');
          });
          result.pusher.connection.bind('state_change', handler);
          result.pusher.connection.bind('connected', handler);
          result.pusher.connection.bind('disconnected', handler);
          cleanup = () => {
            result.pusher.connection.unbind('state_change', handler);
            result.pusher.connection.unbind('connected', handler);
            result.pusher.connection.unbind('disconnected', handler);
            result.pusher.connection.unbind('error', handler);
          };
        }
      } catch (e) {
        if (!active) return;
        setEnabled(false);
        setConnected(false);
        setPusher(null);
        setError(e?.message || String(e));
        console.error('[Realtime] useSoketi error', e);
        setLastSocketError(e?.message || String(e));
      }
    })();

    return () => {
      active = false;
      cleanup?.();
    };
  }, []);

  return useMemo(
    () => ({
      enabled,
      connected,
      pusher,
      error,
      lastState,
      lastSocketError,
    }),
    [enabled, connected, pusher, error, lastState, lastSocketError]
  );
}
